import { FC } from 'react';
import { Image, StyleSheet, TouchableOpacity, View } from 'react-native';
import { useIsDesktop } from '../../../../hooks/useIsDeskTop';
import { Text } from '../../../../components/Text';
import { COLORS, FONTS } from '../../../../constants';

type TabelDeleteableItemProps = {
  name: string;
  description: string;
  price: string;
  onDeleteItem: () => void;
  isCanDelete?: boolean;
};

export const TabelDeleteableItem: FC<TabelDeleteableItemProps> = ({
  name,
  description,
  price,
  onDeleteItem,
  isCanDelete = false,
}) => {
  const isDesktop = useIsDesktop();

  return (
    <View
      style={{
        flexDirection: 'row',
        marginBottom: 15,
        justifyContent: 'space-between',
      }}
    >
      <View
        style={{
          width: '71%',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        <View style={{ width: '100%' }}>
          <Text style={styles.tableContentText}>{name}</Text>
        </View>
        <View style={{ width: '100%' }}>
          <Text style={[styles.tableContentText]}>{description}</Text>
        </View>
      </View>
      <View
        style={{ width: isCanDelete ? '22%' : '29%', flexDirection: 'row' }}
      >
        <Text style={[styles.tableContentText]}>{price}</Text>
      </View>
      {isCanDelete && (
        <TouchableOpacity
          style={{ width: '7%', alignSelf: 'flex-start', marginTop: 3 }}
          onPress={() => {
            onDeleteItem();
          }}
        >
          <Image
            style={{
              width: 20,
              height: 20,
            }}
            source={require('../../../../assets/close-circle-icon.png')}
          />
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  tableContentText: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    fontSize: 17,
    color: COLORS.GREY,
    paddingRight: 2,
  },
});
